export const personOneOnOneSelector = state => state.personOneOnOne;
